import { render, staticRenderFns } from "./ComplianceHeader.vue?vue&type=template&id=3cd24808&scoped=true"
import script from "./ComplianceHeader.vue?vue&type=script&lang=js"
export * from "./ComplianceHeader.vue?vue&type=script&lang=js"
import style0 from "./ComplianceHeader.vue?vue&type=style&index=0&id=3cd24808&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cd24808",
  null
  
)

export default component.exports